<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [{ name: "车辆管理" }, { name: "隐患排查" }],
      menuIndex: "/vehicle/breakRules/list",
      menu: [
        {
          name: "周检",
          path: "/vehicle/investDanger/list",
        },
        {
          name: "月检",
          path: "/vehicle/investDanger/monthList",
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path;
    },
  },
  mounted() {
    this.menuIndex = this.$route.path;
  },
};
</script>
